export enum LinkHoverBehavior {
    default = 'no-underline',
    textWithHoverUnderline = 'hover:underline',
}
